<template>
  <v-menu offset-y="offset-y" left="left" :close-on-content-click="false" content-class="filter-panel">
    <template v-slot:activator="{ on }">
      <div class="button" v-on="on">
        <v-icon>mdi-filter</v-icon>
      </div>
    </template>
    <div class="filter">
      <v-row>
        <v-col cols="9">
          <div class="recent-select mb-3">
            <div class="body-1 pb-2 pb-2 mb-3">{{ $t('filter.recentSelect') }}</div>
            <v-row class="buttons mb-10">
              <v-col cols="auto" v-for="city in currentCities" :key="city.value">
                <v-btn color="primary" outlined="outlined">{{ city.name }}</v-btn>
              </v-col>
            </v-row>
          </div>
          <div class="select-area">
            <div class="body-1 pb-2 pb-2 mb-3">{{ $t('filter.selectArea') }}</div>
            <v-row>
              <v-col class="pt-0 pb-0" cols="6">
                <v-select class="is-primary" :items="cityOptions" item-text="name" item-value="value" label="City" color="primary" full-width="full-width" outlined="outlined"></v-select>
              </v-col>
              <v-col class="pt-0 pb-0" cols="6">
                <v-select class="is-primary" :items="rangeOptions" item-text="name" item-value="value" label="Range" color="primary" full-width="full-width" outlined="outlined"></v-select>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="3">
          <v-btn rounded="rounded" color="primary" outlined="outlined" width="100%">{{ this.$t('filter.customize') }}</v-btn>
        </v-col>
      </v-row>
    </div>
  </v-menu>
</template>

<script>

export default {
  data () {
    return {
      currentCities: [
        {
          name: 'Taipei City',
          value: 'taipei'
        },
        {
          name: 'New Taipei City',
          value: 'new_taipei'
        },
        {
          name: 'Keelung City',
          value: 'keelung_taipei'
        }
      ],
      cityOptions: [
        {
          name: 'Taipei City',
          value: 'taipei'
        },
        {
          name: 'New Taipei City',
          value: 'new_taipei'
        },
        {
          name: 'Keelung City',
          value: 'keelung_taipei'
        }
      ],
      rangeOptions: [
        {
          name: '大安站',
          value: '大安'
        },
        {
          name: '信義站',
          value: '信義'
        },
        {
          name: '永春站',
          value: '永春'
        }
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
  .filter-panel
    width 750px
    padding 20px 35px
    background-color white
</style>
